import {InputText} from "primereact/inputtext";
import React, {useEffect, useState} from "react";
import { Col, Row} from "react-bootstrap";
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";

const TaxCalculator = () => {
    const [salary, setSalary] = useState("");
    const [selectedProvidentPercentage, setSelectedProvidentPercentage] = useState("");
    const [salaryMsg, setSalaryMsg] = useState(false);
    const [providentPercentageMsg, setProvidentPercentageMsg] = useState(false);
    const [nonTaxableSalaryMsg, setNonTaxableSalaryMsg] = useState(false);
    const [taxMonthlyAmount, setTaxMonthlyAmount] = useState("");
    const [taxYearlyAmount, setTaxYearlyAmount] = useState("");
    const [providentFund, setProvidentFund] = useState("");
    const [salaryAfterDeduction, setSalaryAfterDeduction] = useState("");
    const  eobi = 370;
    let roundedProvdntFnd;

    const providentFundPercentage = [
        { label: '5%', value: 1 },
        { label: '8%', value: 2 },
        { label: '10%', value: 3 }
    ]

    const numberFormatter = new Intl.NumberFormat();
    const formatNumber = (value) => {
        if (value === "" || value === null || value === undefined) return "";
        const n = Number((""+value).toString().replace(/,/g, ""));
        if (isNaN(n)) return "";
        return numberFormatter.format(n);
    }
    const parseNumber = (value) => {
        if (value === "" || value === null || value === undefined) return "";
        const cleaned = (""+value).replace(/,/g, "");
        const n = Number(cleaned);
        return isNaN(n) ? "" : n;
    }

    useEffect(() => {
        const saved = JSON.parse(localStorage.getItem("tc-state") || "{}");
        if (saved.salary !== undefined) setSalary(saved.salary);
        if (saved.providentFund !== undefined) setProvidentFund(saved.providentFund);
        if (saved.taxMonthlyAmount !== undefined) setTaxMonthlyAmount(saved.taxMonthlyAmount);
        if (saved.taxYearlyAmount !== undefined) setTaxYearlyAmount(saved.taxYearlyAmount);
        if (saved.salaryAfterDeduction !== undefined) setSalaryAfterDeduction(saved.salaryAfterDeduction);
    }, []);

    console.log("taxYearlyAmount", taxYearlyAmount)

    useEffect(() => {
        localStorage.setItem("tc-state", JSON.stringify({
            salary,
            providentFund,
            taxMonthlyAmount,
            taxYearlyAmount,
            salaryAfterDeduction
        }));
    }, [salary, providentFund, taxMonthlyAmount, taxYearlyAmount, salaryAfterDeduction]);

    const handleReset = () => {
        setSalary("");
        setTaxMonthlyAmount("");
        setTaxYearlyAmount("");
        setProvidentFund("");
        setSalaryMsg(false);
        setSalaryAfterDeduction("");
        setSalaryMsg(false);
        setNonTaxableSalaryMsg(false);
        setProvidentPercentageMsg(false);
    }

    const handleTaxCalculate = () => {
        if (salary === "" && providentFund === "") {
            setSalaryMsg(true);
        }
        else if ((salary !== "" && selectedProvidentPercentage === "") || (providentFund !== "" && selectedProvidentPercentage === "")) {
            setProvidentPercentageMsg(true);
        } else if (providentFund !== "" && salary === "") {
            const provFundNum = parseNumber(providentFund);
            console.log("provFundNum", provFundNum)
            if (selectedProvidentPercentage === 1) {
                const calProvdntFund = provFundNum * 20
                const finalProvdntFund = calProvdntFund / 0.6667;
                const remainder = finalProvdntFund % 1000;

                let roundedSalary;
                if (remainder < 500) {
                    // Agar last 3 digits 500 se kam hain → round down
                    roundedSalary = finalProvdntFund - remainder;
                } else {
                    // Agar 500 ya us se zyada hain → round up
                    roundedSalary = finalProvdntFund + (1000 - remainder);
                }
                setSalary(Math.round(roundedSalary));
            }
            else if (selectedProvidentPercentage === 2) {
                const calProvdntFund = provFundNum * 12.5
                const finalProvdntFund = calProvdntFund / 0.6667;
                const remainder = finalProvdntFund % 1000;

                let roundedSalary;
                if (remainder < 500) {
                    // Agar last 3 digits 500 se kam hain → round down
                    roundedSalary = finalProvdntFund - remainder;
                } else {
                    // Agar 500 ya us se zyada hain → round up
                    roundedSalary = finalProvdntFund + (1000 - remainder);
                }
                setSalary(Math.round(roundedSalary));
            }
            else if (selectedProvidentPercentage === 3) {
                const calProvdntFund = provFundNum * 10
                const finalProvdntFund = calProvdntFund / 0.6667;
                const remainder = finalProvdntFund % 1000;

                let roundedSalary;
                if (remainder < 500) {
                    // Agar last 3 digits 500 se kam hain → round down
                    roundedSalary = finalProvdntFund - remainder;
                } else {
                    // Agar 500 ya us se zyada hain → round up
                    roundedSalary = finalProvdntFund + (1000 - remainder);
                }
                setSalary(Math.round(roundedSalary));
            }
        }
        else if (salary !== "" && providentFund === "") {
            setSalaryMsg(false);
            const salaryNum = parseNumber(salary);
            const yearlySalary = salaryNum * 12;
            const calculateProvdntFnd = salaryNum * .6667;
            if(selectedProvidentPercentage === 1) {
                const calculatedProvdntFnd = calculateProvdntFnd * 0.05;
                const decimalPart = calculatedProvdntFnd - Math.floor(calculatedProvdntFnd);

                if (decimalPart < 0.5) {
                    roundedProvdntFnd = Math.floor(calculatedProvdntFnd);
                } else {
                    roundedProvdntFnd = Math.ceil(calculatedProvdntFnd);
                }
                setProvidentFund(roundedProvdntFnd);
            }
            else if(selectedProvidentPercentage === 2) {
                const calculatedProvdntFnd = calculateProvdntFnd * 0.08;
                const decimalPart = calculatedProvdntFnd - Math.floor(calculatedProvdntFnd);

                if (decimalPart < 0.5) {
                    roundedProvdntFnd = Math.floor(calculatedProvdntFnd);
                } else {
                    roundedProvdntFnd = Math.ceil(calculatedProvdntFnd);
                }
                setProvidentFund(roundedProvdntFnd);
            }
            else if(selectedProvidentPercentage === 3) {
                const calculatedProvdntFnd = calculateProvdntFnd * 0.10;
                const decimalPart = calculatedProvdntFnd - Math.floor(calculatedProvdntFnd);

                if (decimalPart < 0.5) {
                    roundedProvdntFnd = Math.floor(calculatedProvdntFnd);
                } else {
                    roundedProvdntFnd = Math.ceil(calculatedProvdntFnd);
                }
                setProvidentFund(roundedProvdntFnd);
            }

            if(yearlySalary <= 600000) {
                setNonTaxableSalaryMsg(true);
                setSalaryAfterDeduction(salary - roundedProvdntFnd);
            }
            else if (yearlySalary > 600000 && yearlySalary <= 1200000) {
                const exceededAmount = yearlySalary - 600000;
                const taxDeduction = exceededAmount * 0.01;
                const finalTax = taxDeduction / 12;
                setTaxMonthlyAmount(finalTax);
                setTaxYearlyAmount(taxDeduction);
                const salaryAfterTaxDeduction = salaryNum - roundedProvdntFnd - finalTax - eobi;
                setSalaryAfterDeduction(salaryAfterTaxDeduction);
            }
            else if (yearlySalary > 1200000 && yearlySalary <= 2200000) {
                const exceededAmount = yearlySalary - 1200000;
                const taxDeduction = (exceededAmount * 0.11) + 6000;
                const finalTax = taxDeduction / 12;
                setTaxMonthlyAmount(finalTax);
                setTaxYearlyAmount(taxDeduction);
                const salaryAfterTaxDeduction = salaryNum - roundedProvdntFnd - finalTax - eobi;
                setSalaryAfterDeduction(salaryAfterTaxDeduction);
            }
            else if (yearlySalary > 2200000 && yearlySalary <= 3200000) {
                const exceededAmount = yearlySalary - 2200000;
                const taxDeduction = (exceededAmount * 0.23) + 116000;
                const finalTax = taxDeduction / 12;
                setTaxMonthlyAmount(finalTax);
                setTaxYearlyAmount(taxDeduction);
                const salaryAfterTaxDeduction = salaryNum - roundedProvdntFnd - finalTax - eobi;
                setSalaryAfterDeduction(salaryAfterTaxDeduction);
            }
            else if (yearlySalary > 3200000 && yearlySalary <= 4100000) {
                const exceededAmount = yearlySalary - 3200000;
                const taxDeduction = (exceededAmount * 0.30) + 346000;
                const finalTax = taxDeduction / 12;
                setTaxMonthlyAmount(finalTax);
                setTaxYearlyAmount(taxDeduction);
                const salaryAfterTaxDeduction = salaryNum - roundedProvdntFnd - finalTax - eobi;
                setSalaryAfterDeduction(salaryAfterTaxDeduction);
            }
            else if (yearlySalary > 4100000 && yearlySalary <= 10000000) {
                const exceededAmount = yearlySalary - 4100000;
                const taxDeduction = (exceededAmount * 0.35) + 616000;
                const finalTax = taxDeduction / 12;
                setTaxMonthlyAmount(finalTax);
                setTaxYearlyAmount(taxDeduction);
                const salaryAfterTaxDeduction = salaryNum - roundedProvdntFnd - finalTax - eobi;
                setSalaryAfterDeduction(salaryAfterTaxDeduction);
            }
            else if (yearlySalary > 10000000) {
                const exceededAmount = yearlySalary - 4100000;
                const taxDeduction = (exceededAmount * 0.35) + 616000;
                const additionalDeduction = (taxDeduction * 0.09) + taxDeduction;
                const finalTax = additionalDeduction / 12;
                setTaxMonthlyAmount(finalTax);
                setTaxYearlyAmount(additionalDeduction);
                const salaryAfterTaxDeduction = salaryNum - roundedProvdntFnd - finalTax - eobi;
                setSalaryAfterDeduction(salaryAfterTaxDeduction);
            }
        }
    }

    return (
        <div className="tc-shell">
            <div className="tc-card">
                <div className="tc-header">
                    <div>
                        <div className="tc-title"><i className="pi pi-calculator" style={{marginRight:8,color:'#22d3ee'}}></i>Income Tax & Provident Fund Calculator</div>
                    </div>
                    <div className="theme-toggle">
                        <span className="tc-sub">Theme</span>
                        <button onClick={() => {
                            const current = document.documentElement.getAttribute('data-theme') || 'light';
                            const next = current === 'light' ? 'dark' : 'light';
                            document.documentElement.setAttribute('data-theme', next);
                        }}>
                            <i className="pi pi-sun" style={{marginRight:6}}></i>Toggle
                        </button>
                    </div>
                </div>

                <div className="tc-grid">
                    <Row>
                        <Col xs={12} sm={12} md={4} lg={4} >
                            <div className="tc-field">
                                <label>Monthly Salary</label>
                                <InputText
                                    className="w-100"
                                    value={formatNumber(salary)}
                                    onChange={(e) => {
                                        const v = e.target.value;
                                        const parsed = parseNumber(v);
                                        setSalary(parsed);
                                        setSalaryMsg(false);
                                    }}
                                    disabled={providentFund && salary}
                                    placeholder="Enter your salary"
                                />
                                { salaryMsg === true ?
                                    <span className="tc-note ms-1" style={{color: "#ef9a9a", fontSize: "15px"}}>Please enter your salary</span>
                                    : nonTaxableSalaryMsg === true ?
                                        <span className="tc-note ms-1" style={{color: "#ef9a9a", fontSize: "15px"}}>Your salary is tax-free.</span>
                                        : null
                                }
                            </div>
                        </Col>
                        <Col xs={12} sm={12} md={4} lg={4}>
                            <div className="tc-field">
                                <label>Provident Percentage</label>
                            <Dropdown className='w-100' value={selectedProvidentPercentage} onChange={(e) => {
                                setSelectedProvidentPercentage(e.value);
                            }} options={providentFundPercentage} optionLabel="label"
                                      placeholder="Select one"/>
                                { providentPercentageMsg === true ?
                                    <span className="tc-note ms-1" style={{color: "#ef9a9a", fontSize: "15px"}}>Please enter provident percentage</span>
                                        : null
                                }
                            </div>
                        </Col>
                    </Row>

                    <div className='tc-actions'>
                        <Button className="mybtn" onClick={handleTaxCalculate} disabled={providentFund && salary}><i className="pi pi-equals" style={{marginRight:8}}></i>Calculate</Button>
                        <Button className="mybtn secondary" onClick={handleReset}><i className="pi pi-refresh" style={{marginRight:8}}></i>Reset</Button>
                    </div>

                    <div className="tc-hr"></div>

                    <Row>
                        <Col xs={12} sm={12} md={4} lg={4} >
                            <div className="tc-field">
                                <label>Provident Fund Deduction</label>
                                <InputText
                                    className="w-100"
                                    value={formatNumber(providentFund)}
                                    onChange={(e) => {
                                        const v = e.target.value;
                                        const parsed = parseNumber(v);
                                        setProvidentFund(parsed);
                                    }}
                                    disabled={providentFund && salary}
                                    placeholder="Calculated or enter manually"
                                />
                            </div>
                        </Col>
                        <Col xs={12} sm={12} md={4} lg={4} >
                            <div className="tc-field">
                                <label>Monthly Tax Deduction</label>
                                <InputText
                                    className="w-100"
                                    value={formatNumber(taxMonthlyAmount)}
                                    disabled={providentFund && salary}
                                    placeholder={salary <= 50000 && salary > 0 ? "Tax-free salary" : "Auto-calculated"}
                                />
                            </div>
                        </Col>
                        <Col xs={12} sm={12} md={4} lg={4} >
                            <div className="tc-field">
                                <label>Yearly Tax Deduction</label>
                                <InputText
                                    className="w-100"
                                    value={formatNumber(taxYearlyAmount)}
                                    disabled={providentFund && salary}
                                    placeholder={salary <= 50000 && salary > 0 ? "Tax-free salary" : "Auto-calculated"}
                                />
                            </div>
                        </Col>
                    </Row>

                    <div className="tc-hr"></div>

                    <Row>
                        <Col xs={12} sm={12} md={6} lg={6}>
                            <div className="tc-field">
                                <label>Salary After Deduction</label>
                                <InputText
                                    className="w-100"
                                    value={formatNumber(salaryAfterDeduction)}
                                    disabled={providentFund && salary}
                                    placeholder="Auto-calculated"
                                />
                            </div>
                        </Col>
                        <Col xs={12} sm={12} md={6} lg={6} className="d-flex justify-content-center">
                            <div className="tc-stat">
                                <i className="pi pi-info-circle" style={{color:'#34d399'}}></i>
                                <span className="tc-note">EOBI fixed at 370. PF and tax calculated per existing slabs.</span>
                            </div>
                        </Col>
                    </Row>

                    <Row className="mt-5 tax-slab-heading">
                        <Col className="d-flex justify-content-center" xs={12} sm={12} md={12} lg={12}>
                            <h2>Income Tax Slab 2025-2026</h2>
                        </Col>
                    </Row>

                    <Row className="mt-3 tax-slab">
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <p>Where the taxable salary income does not exceed Rs. 600,000, the rate of income tax is 0%.</p>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <p>Where the taxable salary income exceeds Rs. 600,000 but does not exceed Rs. 1,200,000, the rate of income tax is 1% of the amount exceeding Rs. 600,000.</p>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <p>Where the taxable salary income exceeds Rs. 1,200,000 but does not exceed Rs. 2,200,000, the rate of income tax is Rs. 6,000 + 11% of the amount exceeding Rs. 1,200,000.</p>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <p>Where the taxable salary income exceeds Rs. 2,200,000 but does not exceed Rs. 3,200,000, the rate of income tax is Rs. 116,000 + 23% of the amount exceeding Rs. 2,200,000.</p>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <p>Where the taxable salary income exceeds Rs. 3,200,000 but does not exceed Rs. 4,100,000, the rate of income tax is Rs. 346,000 + 30% of the amount exceeding Rs. 3,200,000.</p>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <p>Where the taxable salary income exceeds Rs. 4,100,000, the rate of income tax is Rs. 616,000 + 35% of the amount exceeding Rs. 4,100,000.</p>
                        </Col>
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <p>Provided that in case of an individual deriving income chargeable under the head “Salary”, the surcharge shall be payable at the rate of nine percent of the income tax imposed under Division I of Part I of the First Schedule where the taxable income exceeds rupees ten million in a tax year</p>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}
export default TaxCalculator;